import type { Transition } from 'framer-motion';

export const NOTIFICATION_SPRING: Transition = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
    mass: 0.8,
};

export const NOTIFICATION_FADE: Transition = {
    duration: 0.15,
    ease: 'easeOut',
};

export const NOTIFICATION_FADE_FAST: Transition = {
    duration: 0.12,
    ease: 'easeOut',
};

export const CARD_INITIAL = { opacity: 0, scale: 0.95 };
export const CARD_ANIMATE = { opacity: 1, scale: 1 };
export const CARD_EXIT = { opacity: 0, x: -100, scale: 0.95 };
export const CARD_EXIT_REDUCED = { opacity: 0 };

export const CONTAINER_INITIAL = { opacity: 0, y: 16 };
export const CONTAINER_ANIMATE = { opacity: 1, y: 0 };

export const VIEW_MORE_INITIAL = { opacity: 0, y: 8 };
export const VIEW_MORE_EXIT = { opacity: 0, y: 8 };

export const TRANSITION_INSTANT: Transition = { duration: 0 };

export const getCardTransition = (
    shouldReduceMotion: boolean | null,
): Transition =>
    shouldReduceMotion
        ? TRANSITION_INSTANT
        : {
              layout: NOTIFICATION_SPRING,
              opacity: NOTIFICATION_FADE,
              scale: NOTIFICATION_FADE,
              x: NOTIFICATION_FADE,
          };

export const getViewMoreTransition = (
    shouldReduceMotion: boolean | null,
): Transition =>
    shouldReduceMotion
        ? TRANSITION_INSTANT
        : {
              layout: NOTIFICATION_SPRING,
              opacity: NOTIFICATION_FADE_FAST,
              y: NOTIFICATION_FADE_FAST,
          };
